<div class="frame-in">
    <div class="books" [class.hidden]="loading()">
        <button type="button" class="leave-button" (click)="previousState()"></button>

        <button type="button" class="slider-back" (click)="previous()"></button>
        <button type="button" class="slider-next" (click)="next()"></button>

        <div>
            @for (tab of tabs(); track $index; let i = $index) {

            @if (activeWindow() === i + 1) {
            <div class="blocks-list">

                @for (item of tab; track $index; let j = $index) {
                <div class="item" [class.lock]="item.lock" [routerLink]="item.url">
                    <div class="number">{{ (i * 10) + j + 1 }}</div>
                    <div class="description-box">
                        {{ item.countryTitle }}
                    </div>
                </div>
                }
            </div>
            }
            }
        </div>
        <img class="frame-bg" src="assets/images/books/bg.jpg">
    </div>
</div>

<div class="pagination" [style.left.px]="-styleLeftPx()">
    <div class="wrap">
        @for (tab of tabs(); track $index; let index = $index) {
        <span (click)="activeWindow.set(index + 1)" [class.active]="(index + 1) === activeWindow()">
            {{ index + 1 }}
        </span>
        }
    </div>
</div>
